import { Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersProvider } from '../../../components/providers/FiltersProvider';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import NetworkSettlementContractsList from './NetworkSettlementContractsList';

const breadCrumb = [
    { name: 'Administración' },
    { name: 'Redes comerciales y departamentos', href: menuRoutes.networks.path },
    { name: 'Liquidaciones de Red', href: menuRoutes.networks.path + menuRoutes.networks.settlements },
    { name: 'Detalle por contratos' },
];

const NetworkSettlementContractsListWrapper = () => {
    const [searchParams] = useSearchParams();
    const now = new Date();

    const month = Number(searchParams.get('month') || (now.getMonth() + 1));
    const year = Number(searchParams.get('year') || now.getFullYear());
    const settlementStatus = searchParams.get('settlement_status');

    return (
        <Fragment>
            <FiltersProvider
                defaultFilterFilters={{
                    month,
                    year,
                    settlement_status: settlementStatus || null,
                }}
            >
                <PageHeader title="Liquidaciones de Red - Detalle" breadcrumb={breadCrumb} />
                <NetworkSettlementContractsList />
            </FiltersProvider>
        </Fragment>
    );
};

export default NetworkSettlementContractsListWrapper;
